// IMAGE GALLERY
function imageGallery(imgs) {
    var featuredImage = document.getElementById("featuredImage");
    featuredImage.src = imgs.dataset.img;
    featuredImage.alt = imgs.alt;
    featuredImage.parentElement.style.display = "block";
}

// IMAGE GALLERY ACTIVE CLASS
var header = document.getElementById("product-image-gallery");
var btns = header.getElementsByClassName("product-image");
for (var i = 0; i < btns.length; i++) {
	btns[i].addEventListener("click", function() {
	var current = document.getElementsByClassName("active");
	if (current.length > 0) { 
	current[0].className = current[0].className.replace(" active", "");
	}
	this.className += " active";
	});
}
